// src/components/Sidebar.js
import React from 'react';
// Import NavLink
import { NavLink } from 'react-router-dom';
import '../styles/Sidebar.css';
import logoImage from '../assets/icons/zappyrewards-logo.svg'

// --- NEW ---
// Placeholder function to determine if program-specific links should be active.
// We'll replace this with actual state logic later.
const isProgramSelected = () => {
  // For now, assume no program is selected initially.
  // In later steps, this will check global state.
  return false;
};

const Sidebar = () => {
  const programSpecificLinksDisabled = !isProgramSelected(); // Example usage (currently always true)

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <img src={logoImage} alt="ZappyRewards Logo" className="logo-image" />
      </div>
      <nav className="sidebar-nav">
        {/* === General Links === */}
        <NavLink
          to="/dashboard"
          end // Ensures exact match for the root dashboard link
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          Dashboard
        </NavLink>

        {/* === Program Setup & Selection === */}
        <NavLink
            to="/setup-program"
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
            Setup New Program
        </NavLink>
        {/* --- NEW LINK --- */}
        <NavLink
            to="/select-program" // New route for selecting a program
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
            Select Program
        </NavLink>

        {/* === Program-Specific Links (depend on selection) === */}
        {/* We will add logic later to enable/disable or show/hide these based on selection */}
        {/* For now, they just link to placeholder routes */}
        <NavLink
          to="/manage-program"
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          // Example of conditionally disabling using aria-disabled and styling (needs CSS)
          // style={programSpecificLinksDisabled ? { pointerEvents: 'none', opacity: 0.6 } : {}}
          // aria-disabled={programSpecificLinksDisabled}
          // onClick={(e) => programSpecificLinksDisabled && e.preventDefault()} // Prevent navigation if disabled
        >
          Manage Program
        </NavLink>
        <NavLink
          to="/rewards-settings"
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
            Rewards Settings
        </NavLink>
         <NavLink
           to="/participants"
           className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
         >
            Participants
        </NavLink>
         <NavLink
           to="/analytics"
           className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
         >
            Analytics
        </NavLink>
         <NavLink
           to="/scan-qr"
           className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
         >
            Scan QR
        </NavLink>

        {/* === Account === */}
        <NavLink
          to="/profile"
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
            Profile
        </NavLink>
        <NavLink
          to="/subscription"
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
            Subscription
        </NavLink>

        {/* === Other Links === */}
         <NavLink
           to="/help"
           className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          >
            Help
        </NavLink>
      </nav>
    </aside>
  );
};

export default Sidebar;